// extracted by mini-css-extract-plugin
export default {"containerLogout":"VxixI","userName":"qX6Ge","buttonHidden":"UyRtI"};